import { z } from "zod";

import { ColorIndexSchema } from "./ColorIndexSchema";
import { ShadeSchema } from "./ShadeSchema";

export const ButtonColorSchema = z.object({
    color: ColorIndexSchema,
    shade: ShadeSchema,
});
